import React from "react";

export const Image = ({ title, largeImage, smallImage, onImageClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (onImageClick) {
      onImageClick(largeImage, title);
    }
  };

  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a
          href={largeImage}
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          <div className="hover-text" style={{ display: "none" }}>
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </a>
      </div>
    </div>
  );
};
